// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__aOSsm","white":"styles_white__5Uk0O","overParent":"styles_overParent__mrRug"};